(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/reducers/chat-meta-reducer.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/reducers/chat-meta-reducer.js'); 
'use strict';

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  actions: {
    CHAT_DELETE_MESSAGE_FAILURE,
    CHAT_DELETE_MESSAGE_SUCCESS,
    CHAT_DELETE_MESSAGE_INIT,
    CHAT_RECEIVE_MESSAGE,
    CHAT_PURGE_ROOM
  },
  constants: {
    MESSAGE_STATUS_DELETE_PENDING,
    MESSAGE_STATUS_DELETED,
    MESSAGE_STATUS_DELETE_FAILED,
    SERVER_MESSAGE_STATUS_DELETED
  }
} = svs.components.chat.chatData;
const chatMetaReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const {
    messageId,
    roomId,
    type
  } = action;
  switch (type) {
    case CHAT_DELETE_MESSAGE_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [messageId]: _objectSpread(_objectSpread({}, (state[roomId] || {})[messageId]), {}, {
            status: MESSAGE_STATUS_DELETE_PENDING
          })
        })
      });
    case CHAT_DELETE_MESSAGE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [messageId]: _objectSpread(_objectSpread({}, (state[roomId] || {})[messageId]), {}, {
            status: MESSAGE_STATUS_DELETED
          })
        })
      });
    case CHAT_DELETE_MESSAGE_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [messageId]: _objectSpread(_objectSpread({}, (state[roomId] || {})[messageId]), {}, {
            status: MESSAGE_STATUS_DELETE_FAILED,
            error: action.error
          })
        })
      });
    case CHAT_RECEIVE_MESSAGE:
      {
        if (action.messageData.serverStatus === SERVER_MESSAGE_STATUS_DELETED &&
        (state[roomId] || {})["".concat(action.messageData.id)]) {
          const _state$roomId = state[roomId],
            _ref = "".concat(action.messageData.id),
            {
              [_ref]: deleteMe
            } = _state$roomId,
            remainingRoomMeta = _objectWithoutProperties(_state$roomId, [_ref].map(_toPropertyKey));
          return _objectSpread(_objectSpread({}, state), {}, {
            [roomId]: remainingRoomMeta
          });
        }
        return state;
      }
    case CHAT_PURGE_ROOM:
      {
        const _ref2 = "".concat(action.roomId),
          {
            [_ref2]: deleteMe
          } = state,
          saveUs = _objectWithoutProperties(state, [_ref2].map(_toPropertyKey));
        return saveUs;
      }
    default:
      return state;
  }
};
setGlobal('svs.components.chat.chatData.reducers.chatMetaReducer', chatMetaReducer);
 })(window);